import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import {
  CommunityIcon,
  FouramIcon,
  ProjectsIcon,
  TasksIcon,
} from "../community/icons";
import { EditPencile } from "../reusableComponents/svgIcons";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getUserCountLength } from "../../API/store/actions/auth";
import CommunitiesList from "./communtiesList";
import ProjectsList from "./MemberLists";
import MemberLists from "./MemberLists";
import UserInfo from "./userInfo";
import Lang from "../../userPreferences/staticWords";
import PostsIndex from "../userProfile/posts/postsIndex";

const AboutUser = ({ details, id, setId, memberId }) => {
  const userToken = useSelector((state) => state.login.userToken);
  const userLogged = useSelector((state) => state.login.userData);

  const [counts, setCounts] = useState({});

  useEffect(() => {
    resolver(getUserCountLength, setCounts, memberId, userToken);
  }, []);

  if (details)
    return (
      <div className="d-flex flex-column">
        <div
          className="col-12 py-3 d-flex justify-content-center tabs-stickyClass"
          style={{ backgroundColor: "rgb(242, 242, 242)", zIndex: 10 }}
        >
          <div className="d-flex flex-wrap justify-content-center col-12 container-md">
            <div className="col-xl-2 col-md-3 d-flex flex-column align-items-center justify-content-center">
              <CardWithTitleAndIcon
                containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                  id == "A5" ? "activeButton" : ""
                }`}
                style={{
                  backgroundColor: "rgb(242, 242, 242)",
                  cursor: "pointer",
                }}
                borderColor={"rgb(242, 242, 242)"}
                height={150}
                width={165}
                customImage={"/assets/images/profile-user (3).png"}
                imgHeight={70}
                imgWidth={70}
                containerImgHeight={70}
                containerImgWidth={70}
                id={"A5"}
                onClick={(e) => {
                  setId(e.currentTarget.id);
                }}
                cardTitle={id == "A5" ? "المعلومات الشخصية" : ""}
              />
            </div>

            {/* <div className="col-xl-2 col-lg-3 d-flex flex-column align-items-center justify-content-center">
              <CardWithTitleAndIcon
                containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                  id == "A6" ? "activeButton" : ""
                }`}
                style={{
                  backgroundColor: "rgb(242, 242, 242)",
                  cursor: "pointer",
                }}
                borderColor={"rgb(242, 242, 242)"}
                height={150}
                width={165}
                hasSVG={<FouramIcon length={counts?.data?.forumCount ?? 0} />}
                imgHeight={85}
                imgWidth={100}
                containerImgHeight={85}
                containerImgWidth={100}
                id={"A6"}
                onClick={(e) => {
                  setId(e.currentTarget.id);
                }}
                cardTitle={id == "A6" ? "المنشورات" : ""}
              />
            </div> */}

            {userLogged?.memberId == memberId || userLogged?.isAdmin ? (
              <>
                <div className="col-xl-2 col-md-3 d-flex flex-column align-items-center justify-content-center">
                  <CardWithTitleAndIcon
                    containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                      id == "A1" ? "activeButton" : ""
                    }`}
                    style={{
                      backgroundColor: "rgb(242, 242, 242)",
                      cursor: "pointer",
                    }}
                    borderColor={"rgb(242, 242, 242)"}
                    height={150}
                    width={165}
                    hasSVG={
                      <CommunityIcon
                        length={counts?.data?.communityCount ?? 0}
                      />
                    }
                    imgHeight={75}
                    imgWidth={90}
                    containerImgHeight={75}
                    containerImgWidth={90}
                    id={"A1"}
                    onClick={(e) => {
                      setId(e.currentTarget.id);
                    }}
                    cardTitle={id == "A1" ? Lang.communities : ""}
                  />
                </div>
                {/* <div className="col-xl-2 col-md-3 d-flex flex-column align-items-center justify-content-center">
                  <CardWithTitleAndIcon
                    containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                      id == "A2" ? "activeButton" : ""
                    }`}
                    style={{
                      backgroundColor: "rgb(242, 242, 242)",
                      cursor: "pointer",
                    }}
                    borderColor={"rgb(242, 242, 242)"}
                    height={150}
                    width={165}
                    hasSVG={
                      <ProjectsIcon length={counts?.data?.projectCount ?? 0} />
                    }
                    imgHeight={75}
                    imgWidth={90}
                    containerImgHeight={75}
                    containerImgWidth={90}
                    id={"A2"}
                    onClick={(e) => {
                      setId(e.currentTarget.id);
                    }}
                    cardTitle={id == "A2" ? Lang.projectsNavTab : ""}
                  />
                </div> */}
                <div className="col-xl-2 col-md-3 d-flex flex-column align-items-center justify-content-center">
                  <CardWithTitleAndIcon
                    containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                      id == "A3" ? "activeButton" : ""
                    }`}
                    style={{
                      backgroundColor: "rgb(242, 242, 242)",
                      cursor: "pointer",
                    }}
                    borderColor={"rgb(242, 242, 242)"}
                    height={150}
                    width={165}
                    hasSVG={<TasksIcon length={counts?.data?.taskCount ?? 0} />}
                    imgHeight={75}
                    imgWidth={90}
                    containerImgHeight={75}
                    containerImgWidth={90}
                    id={"A3"}
                    onClick={(e) => {
                      setId(e.currentTarget.id);
                    }}
                    cardTitle={id == "A3" ? Lang.tasksNavTab : ""}
                  />
                </div>
                {/* <div className="col-xl-2 col-md-3 d-flex flex-column align-items-center justify-content-center">
                  <CardWithTitleAndIcon
                    containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 ${
                      id == "A4" ? "activeButton" : ""
                    }`}
                    style={{
                      backgroundColor: "rgb(242, 242, 242)",
                      cursor: "pointer",
                    }}
                    borderColor={"rgb(242, 242, 242)"}
                    height={150}
                    width={165}
                    hasSVG={
                      <FouramIcon length={counts?.data?.forumCount ?? 0} />
                    }
                    imgHeight={85}
                    imgWidth={100}
                    containerImgHeight={85}
                    containerImgWidth={100}
                    id={"A4"}
                    onClick={(e) => {
                      setId(e.currentTarget.id);
                    }}
                    cardTitle={id == "A4" ? Lang.discussionCirclesNavTab : ""}
                  />
                </div>{" "} */}
              </>
            ) : null}
          </div>
        </div>

        {id == "A1" ? <CommunitiesList id={id} memberId={memberId} /> : null}
        {id == "A2" || id == "A3" || id == "A4" ? (
          <MemberLists id={id} memberId={memberId} />
        ) : null}
        {id == "A5" ? <UserInfo details={details} /> : null}
        {id == "A6" ? <PostsIndex id={id} guestId={memberId} /> : null}
      </div>
    );
  return <div></div>;
};

export default AboutUser;
